import { API_ENDPOINT, ORG_ID } from '../Constants';
const ACCOUNT_SERVICE_BASE_URL = API_ENDPOINT
const CONTENT_SERVICE_BASE_URL = API_ENDPOINT
export default {
    //auth
    // allOrgs: `${API_ENDPOINT}/orgs`,
    // orgDetails: (orgId: string, queryString: any) => `${API_ENDPOINT}/orgs/${orgId}${queryString}`,
    // userMetaData: (queryString: string) => `${API_ENDPOINT}/provider${queryString}`,
    // roles:`${API_ENDPOINT}/roles`,
    // userList: (orgId: string) => `${API_ENDPOINT}/users`,
    // samlLogin: (queryString: string) => `${API_ENDPOINT}/auth/saml/signin${queryString}`,
    // authCred: `${API_ENDPOINT}/auth/credentials`,
    // createUser: `${API_ENDPOINT}/users`,
    //updateRole:(orgId: string,id:string) => `${API_ENDPOINT}/roles/${id}`,
    // updateUser: (orgId: string, id: string) => `${API_ENDPOINT}/users/${id}`,

    //auth
    allOrgs: `${ACCOUNT_SERVICE_BASE_URL}/orgs`,
    deleOrgDetails: (orgId: string, queryString?:string) => `${ACCOUNT_SERVICE_BASE_URL}/orgs/${orgId}${queryString}`,
    orgDetails: (orgId: string, queryString: any) => `${ACCOUNT_SERVICE_BASE_URL}/orgs/${orgId}${queryString}`,
    customLogin: (orgId: string) => `${ACCOUNT_SERVICE_BASE_URL}/orgs/${orgId}/customlogin`,
    userMetaData: (queryString: string) => `${ACCOUNT_SERVICE_BASE_URL}/provider${queryString}`,
    roles: (orgId: string) => `${ACCOUNT_SERVICE_BASE_URL}/orgs/${orgId}/roles?orgId=${orgId}`,
    userList: (orgId: string) => `${ACCOUNT_SERVICE_BASE_URL}/users?orgId=${orgId}`,
    samlLogin: (queryString: string) => `${ACCOUNT_SERVICE_BASE_URL}/auth/saml/signin${queryString}`,
    authCred: (orgId: string) => `${ACCOUNT_SERVICE_BASE_URL}/auth/credentials?orgId=${orgId}`,
    removeAuthCred: (orgId: string, clientId: string) => `${ACCOUNT_SERVICE_BASE_URL}/auth/credentials/${clientId}?orgId=${orgId}`,
    createUser: (orgId: string) => `${ACCOUNT_SERVICE_BASE_URL}/users?orgId=${orgId}`,
    updateRole: (orgId: string, id: string) => `${ACCOUNT_SERVICE_BASE_URL}/roles/${encodeURIComponent(id)}?orgId=${orgId}`,
    updateUser: (orgId: string, id: string) => `${ACCOUNT_SERVICE_BASE_URL}/users/${encodeURIComponent(id)}?orgId=${orgId}`,
    searchAccount: (string: string) => `${ACCOUNT_SERVICE_BASE_URL}/orgs/search?searchString=${encodeURIComponent(string)}`,
    orgMFA: (orgId: string) => `${ACCOUNT_SERVICE_BASE_URL}/mfa?orgId=${orgId}`,
    subAccountSearch:(orgId:string, search: string,) => `${ACCOUNT_SERVICE_BASE_URL}/orgs/${orgId}/accounts?searchString=${encodeURIComponent(search)}`,
    resetUser:`${ACCOUNT_SERVICE_BASE_URL}/users/reset`,



    //forms
    logs: (id: string, deviceId: string, itemsPerPage: any) => `${API_ENDPOINT}/orgs/${ORG_ID()}/logs/entity/${id}?entityId=${encodeURIComponent(deviceId)}&itemsPerPage=${itemsPerPage}`,
    files: (key: string) => `${API_ENDPOINT}/orgs/${ORG_ID()}/files?key=${key}`,

    //jobs
    jobs: (id: string, type: string) => `${API_ENDPOINT}/job?orgId=${ORG_ID()}&id=${encodeURIComponent(id)}&type=${type}`,

    //group

    groupFilter: (id: string, orgId?: string) => `${API_ENDPOINT}/filters/${id}?orgId=${orgId}`,
    filter: (id: string, orgId?: string) => `${API_ENDPOINT}/filters/${id}?orgId=${orgId}`,
    filters: (orgId?: string) => `${API_ENDPOINT}/filters?orgId=${orgId}`,
    filterDevices: (id: string, orgId?: string) => `${API_ENDPOINT}/filters/${id}/devices?orgId=${orgId}`,
    // groupDetails: (id: string) => `${API_ENDPOINT}/groups?orgId=${ORG_ID()}&groupId=${encodeURIComponent(id)}`,
    groupDetails: (id: string) => `${API_ENDPOINT}/groups/${encodeURIComponent(id)}?orgId=${ORG_ID()}`,
    groupDefault: (id: string) => `${API_ENDPOINT}/groups/DEFAULT?orgId=${id}`,
    groupPublish: (orgId: string) => `${API_ENDPOINT}/groups/playlists?orgId=${orgId}`,
    // groupPublish: (orgId: string) => `http://localhost:3000/dev/groups/playlists?orgId=${orgId}`,
    groupData: (id: string, orgId?: string) => `${API_ENDPOINT}/groups/${id}?orgId=${orgId}`,
    groupDeleteWithDevices: (id: string) => `${API_ENDPOINT}/groups/${id}/devices`,
    group: `${API_ENDPOINT}/groups`,
    software: (orgId: string) => `${API_ENDPOINT}/software?orgId=${orgId}`,
    // software: (orgId: string) => `http://localhost:3000/dev/software?orgId=${orgId}`,
    unsavedFilter: (orgId: string) => `${API_ENDPOINT}/unsaved/filters?orgId=${orgId}`,
    // unsavedFilter: (orgId: string) => `http://localhost:3000/dev/unsaved/filters?orgId=${orgId}`,



    //devices
    deviceDetails: (id: string, orgId?: string) => `${API_ENDPOINT}/devices/${id}?orgId=${orgId ? orgId : ORG_ID()}`,
    updateSerial: () => `${API_ENDPOINT}/devices/rma`,
    deleteCategoryFromDevice: (deviceId: string, orgId?: string) => `${API_ENDPOINT}/categories/devices/${deviceId}?orgId=${orgId ? orgId : ORG_ID()}`,
    deviceLogs: (queryString: string) => `${API_ENDPOINT}/device/logs${queryString}`,
    devicesearch: (queryString: string) => `${API_ENDPOINT}/devices/search${queryString}`,
    deviceContentStatus: (id: string, orgId: string) => `${API_ENDPOINT}/device/${id}/content/status?orgId=${orgId}`,
    // deviceContentStatus: (id: string, orgId: string) => `http://localhost:3000/dev/device/${id}/content/status?orgId=${orgId}`,
    firmwares: (type: string, deviceId: string) => `${API_ENDPOINT}/devices/${deviceId}/firmwares?requestType=${type}`,
    firmwaresList: (modelNo: string, version: string) => `${API_ENDPOINT}/devices/firmwares?model=${modelNo}&build=${version}`,
    uploadlogs: (type: string) => `${API_ENDPOINT}/device/uploadlogs`,
    devices: `${API_ENDPOINT}/devices`,
    devicesCount: `${API_ENDPOINT}/devices/count`,
    devicesSearchCount: `${API_ENDPOINT}/devices/search/count`,
    reports: (orgId: string) => `${API_ENDPOINT}/devices/reports/${orgId}`,
    deviceToGroup: `${API_ENDPOINT}/groups/devices`,
    devicesToCategory: `${API_ENDPOINT}/devices/categories`,
    uploadedLogs: (orgId: string, deviceId: string) => `${API_ENDPOINT}/device/${deviceId}/logs?orgId=${orgId}`,
    // uploadedLogs: (orgId: string, deviceId: string) => `http://localhost:3000/dev/device/${deviceId}/logs?orgId=${orgId}`,
    getDevicesByContentIdAPI: (contentId: string, orgId: string) => `${API_ENDPOINT}/devices/contentdeployment/${contentId}?orgId=${orgId}`,
    deviceOSCareWarrantyAPI: (serial: string) => `${API_ENDPOINT}/warranty/${serial}`,




    //contents
    contentsDetails: (id: string, orgId: string) => `${CONTENT_SERVICE_BASE_URL}/contents/${id}?orgId=${orgId}`,
    deleteContents: (id: string) => `${CONTENT_SERVICE_BASE_URL}/contents/${id}`,
    contentsType: (type: string) => `${CONTENT_SERVICE_BASE_URL}/contents?contentTypes=${type}`,
    allContents: `${CONTENT_SERVICE_BASE_URL}/contents`,
    contentToCategory: (catId: string, contentId: string) => `${CONTENT_SERVICE_BASE_URL}/contents/${contentId}/categories/${catId}`,
    helperUpdate: (orgId: string, type: string) => `${CONTENT_SERVICE_BASE_URL}/helper/update?orgId=${orgId}&contentType=${type}`,
    screenShotUrl: `${API_ENDPOINT}/create-screenshot-url`,

    // helperUpdate: (orgId: string, type: string) => `http://localhost:3000/dev/helper/update?orgId=${orgId}&contentType=${type}`,
    contentSearch: (orgId: string, query: string) => `${CONTENT_SERVICE_BASE_URL}/contents/search?orgId=${orgId}&${query}`,
    allContentList: (orgId?: string) => `${CONTENT_SERVICE_BASE_URL}/contents/all?orgId=${orgId ? orgId : ORG_ID()}`,
    checkAssociations: (orgId?: string) => `${CONTENT_SERVICE_BASE_URL}/device/associations?orgId=${orgId ? orgId : ORG_ID()}`,


    //deviceContent
    deviceContent: (orgId: string) => `${API_ENDPOINT}/devices/content?orgId=${orgId}`,
    publishContent: (orgId: string) => `${API_ENDPOINT}/devices/publish?orgId=${orgId}`,

    //categories
    categories: `${API_ENDPOINT}/categories`,
    updateCategories: (catId: string) => `${API_ENDPOINT}/categories/${catId}`,



    //dashboard
    dashboard: (id: string) => `${API_ENDPOINT}/orgs/${id}/dashboard`,
    getActivityLog: `${API_ENDPOINT}/orgs/${ORG_ID()}/logs/entity/getall?itemsPerPage=10`,
    // eventlogs: `${API_ENDPOINT}/eventlogs?orgId=${ORG_ID()}`,
    eventlogs:(orgId: string)=> `${API_ENDPOINT}/eventlogs?orgId=${orgId}`,
    eventFilters:(orgId: string)=> `${API_ENDPOINT}/eventfilters?orgId=${orgId}`,


    //deployment
    recentDeploymentPackage: (queryString: string) => `${API_ENDPOINT}/orgs/${ORG_ID()}/packages/${queryString}`,
    savePackage: (queryString: string) => `${API_ENDPOINT}/orgs/${ORG_ID()}/packages/save${queryString}`,
    package: (packageId: string) => `${API_ENDPOINT}/orgs/${ORG_ID()}/packages/${packageId}`,
    deployment: `${API_ENDPOINT}/deployments`,
    packages: (orgId: string) => `${API_ENDPOINT}/orgs/${orgId}/packages`,
    deployments: (orgId: string) => `${API_ENDPOINT}/deployments?orgId=${orgId}`,
    // deployments: (orgId: string) => `http://localhost:3000/dev/deployments?orgId=${orgId}`,
    saveDeployments: (orgId: string) => `${API_ENDPOINT}/deployments/save?orgId=${orgId}`,
    // saveDeployments: (orgId: string) => `http://localhost:3000/dev/deployments/save?orgId=${orgId}`,
    singleDeployments: (orgId: string, packageId: string) => `${API_ENDPOINT}/deployments/${packageId}?orgId=${orgId}`,
    // singleDeployments: (orgId: string, packageId: string) => `http://localhost:3000/dev/deployments/${packageId}?orgId=${orgId}`,


    //scheduler
    scheduledList: (queryString: string) => `${API_ENDPOINT}/orgs/${ORG_ID()}/packages/schedule${queryString}`,
    contents: (contentId: string) => `${API_ENDPOINT}/contents/${contentId}`,
    groups: (groupId: string) => `${API_ENDPOINT}/orgs/${ORG_ID()}/groups/${groupId}`,

    //subscriptions
    prices: (id: string) => `${API_ENDPOINT}/payment/orgs/${ORG_ID()}/prices?productId=${id}&mode=polaris`,
    plans: `${API_ENDPOINT}/orgs/pricing`,
    updatesubscription: (subId: string) => `${API_ENDPOINT}/subscriptions/${subId}?mode=polaris`,
    subscriptionInvoice: (subId: string) => `${API_ENDPOINT}/payment/orgs/${ORG_ID()}/subscriptions/${subId}/invoice?mode=polaris`,

    //saml
    samlList: (orgId: string) => `${API_ENDPOINT}/auth/saml/providers/${orgId}`,
    saml: `${API_ENDPOINT}/auth/saml/providers`,
    teamviewer: (orgId: string) => `${API_ENDPOINT}/teamviewer/apps?orgId=${orgId}`,
    enableTeamviewer: (orgId: string, version: string) => `${API_ENDPOINT}/teamviewer/apps?orgId=${orgId}&version=${version}`,
    validateTeamviewer: (orgId: string) => `${API_ENDPOINT}/devices/validate/tv?orgId=${orgId}`,

    //teamviewer
    defaultTeamviewerVersions: `${API_ENDPOINT}/teamviewer/default`,

    // User Profile
    userProfile: (email: string, orgId: any) => `${API_ENDPOINT}/users/email?userEmail=${encodeURIComponent(email)}&orgId=${orgId}`,
    logout: () => `${API_ENDPOINT}/logout`
};
